import { Dropdown } from "../../../FormComponents/Dropdown";
import {useTranslation} from "react-i18next";

const VonServiceSelection = ({ services, selectedService, onChange }) => {

    const { t } = useTranslation();
    
    const options = services.map(product => {
        return {
            id: product.productNumber,
            name: product.product
        }
    });

    const selectService = (value) => {
        const selectedService = services.find(product => product.productNumber === value);
        onChange(selectedService);
    }

    return <div>
        <div className="mb-10">
            <Dropdown label={t("employeeLicenses.service")} options={options} value={selectedService} onChange={(value) => selectService(value)}/>
        </div>
    </div>
}

export default VonServiceSelection;